import React from 'react';
import { commissionAccrualSummary } from '../utils/commissionAccrualDisplay';

/* CommissionAccrualDisplay -- how the books treat commissions, READ-ONLY (commission ship 5; Brian Q3 a: set in the onboarding
   wizard, no live edit; Q10 a later change goes through Brian). TEXT ONLY: no control, no handler, no request -- so there is
   nothing here for a <ViewOnly> region to grey and nothing for verify-view-only.js to gate. Every role sees it.
   `accrual` is the engine's object (commissionAccrual.js commissionAccrualFromSettings); never asked shows "Not answered".
   `accountLabel` is the linked account's label (null = none linked). The words are utils/commissionAccrualDisplay's. */

const FONT = "'DM Sans',-apple-system,sans-serif";

export default function CommissionAccrualDisplay({ accrual, accountLabel = null, style }) {
  return (
    <div data-testid="commission-accrual-display" style={{
      padding: '10px 18px', borderRadius: 12, background: 'rgba(90,95,192,0.04)',
      border: '1px solid rgba(90,95,192,0.14)', fontFamily: FONT, ...style,
    }}>
      <div style={{ fontSize: 13, color: '#1A1C2E' }}>
        <span style={{ fontWeight: 700 }}>Commissions: </span>
        <span data-testid="commission-accrual-summary">{commissionAccrualSummary(accrual, accountLabel)}</span>
      </div>
    </div>
  );
}
